import AmioHttpService from '@/services/amio/amio-http.service'

class ToolsService extends AmioHttpService {
  async create(tool) {
    try {
      const response = await this.requestPost('/tools', tool)
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async update(id, tool) {
    try {
      const response = await this.requestPatch(`/tools/${id}`, tool)
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async list() {
    try {
      const response = await this.requestGet('/tools')
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async delete(id) {
    try {
      await this.requestDelete(`/tools/${id}`)
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async test(id, payload) {
    try {
      const response = await this.requestPost(`/tools/${id}/test`, payload)
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async getReferences(id) {
    try {
      const response = await this.requestGet(`/tools/${id}/references`)
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }
}

export default new ToolsService()
